import { faWarning } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

function Warning({ message }) {
  const { t } = useTranslation();

  return (
    <div className="warning" role="alert" aria-live="assertive">
      <FontAwesomeIcon icon={faWarning} className="warning-icon" />
      {message ?? t('T150')}
    </div>
  );
}

export default Warning;
